import {
    documentLoadEvent,
    inputEvent, keyupEvent,
    resetEvent,
    submitEvent,
    windowScrollEvent
} from "../../../webpack/modules/events";
import {
    closeLoader,
    closeResults, openLoader,
    openResults,
    renderFullView,
    updateQueryParameter
} from "../../../webpack/modules-optimized/searcher-v2";
import {checkElementIsVisibleInViewport} from "../../../scripts/Tools/visible-element-observer";
import {isDesktop} from "../../../webpack/modules/devices";

documentLoadEvent(updateResultContainerClasses);
windowScrollEvent(updateResultContainerClasses);

submitEvent('.search-form', false, function(element, event) {
    event.preventDefault();
});

const botPatternG = "(spider|crawler|claude|perplexity|anthropic|gpt|open-ai|googlebot|google-?(bot|extended|cloudvertexbot|read-aloud|site-verification|inspectiontool|other|image)|adsbot-google|apis-google|feedfetcher-google|mediapartners-google|storebot-google|duplexweb-google|google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
const reG = new RegExp(botPatternG,"i");
const userAgentG = navigator.userAgent;
const isEmptyUA = !userAgentG || userAgentG.trim() === "";
const is_crawlerG = reG.test(userAgentG) || navigator.webdriver || isEmptyUA;

let timeOutRead;
inputEvent('.search-form input', false, function(input) {
    if (is_crawlerG) {
        return;
    }
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let resultsContainer = container.querySelector('.searcher-results');
    let search = input.value;
    let locale = document.documentElement.lang;
    let limitWords = locale.includes('zh') || locale.includes('ja') || locale.includes('ko') ? 0 : 2;

    if (search.length > limitWords) {
        openLoader();
        openResults();
    } else {
        closeResults();
        closeLoader();
    }

    clearTimeout(timeOutRead);
    timeOutRead = setTimeout(async function() {
        if (search.length > limitWords) {
            await renderFullView(search);
            if (!isDesktop()) input.blur();
        } else {
            resultsContainer.innerHTML = '';
        }
        updateQueryParameter(search);
    }, 1000);
});

function updateResultContainerClasses()
{
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let isVisibleHeaderMessage = checkElementIsVisibleInViewport(document.querySelector('.header-messages'));
    let resultsContainer = container.querySelector('.searcher-results');

    if (isVisibleHeaderMessage && !resultsContainer.classList.contains('header-messages-visible')) resultsContainer.classList.add('header-messages-visible');
    else if (!isVisibleHeaderMessage && resultsContainer.classList.contains('header-messages-visible')) resultsContainer.classList.remove('header-messages-visible');
}